import { createContext as createStoreContext, FSetupStore } from '../../store/index.js';
const {
  Provider: StoreProvider,
  useStore,
  useStoreApi,
  Context: StoreContext,
} = createStoreContext<FSetupStore>();

export { StoreProvider, useStore, useStoreApi, StoreContext };
